import { makeAutoObservable } from "mobx";
import { reachableBranchIds } from "../app/modules/auth/core/branchSession";

class PermissionStore {
  permissions: string[] = [];
  organizationWide: string[] = [];
  byBranch: Record<string, string[]> = {};
  permissionsLoaded: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setPermissionsLoaded(loaded: boolean): void {
    this.permissionsLoaded = loaded;
  }

  isPermissionsLoaded(): boolean {
    return this.permissionsLoaded;
  }

  setPermissions(permissions: string[]): void {
    this.permissions = permissions;
    if (permissions.length === 0) {
      this.organizationWide = [];
      this.byBranch = {};
    }
  }

  setPermissionPayload(payload: {
    data?: string[];
    organization_wide?: string[];
    by_branch?: Record<string, string[]>;
  }): void {
    this.permissions = payload.data ?? [];
    this.organizationWide = payload.organization_wide ?? [];
    this.byBranch = payload.by_branch ?? {};
  }

  addPermission(permission: string): void {
    if (!this.permissions.includes(permission)) {
      this.permissions.push(permission);
    }
  }

  removePermission(permission: string): void {
    this.permissions = this.permissions.filter((p) => p !== permission);
  }

  hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }

  /** Branch ids the caller can reach (by_branch keys with permissions). */
  reachableBranchIds(): string[] {
    return reachableBranchIds(this.byBranch);
  }

  hasPermissionOnBranch(permission: string, branchId: string | null): boolean {
    if (this.organizationWide.includes(permission)) {
      return true;
    }
    if (!branchId) {
      return this.permissions.includes(permission);
    }
    return (this.byBranch[branchId] ?? []).includes(permission);
  }
}

export default PermissionStore;
